import { apiGet } from "./api.ts";
import type { ConfigCode } from "../types/ConfigCode";

export async function fetchValidConfigCode() {
  return apiGet<ConfigCode>(`/valid-config-code`);
}


